import LinkIcon from '../../assets/icons/link.svg'
import { useContext } from 'react'
import { AppContext } from '../../../App'
import './PartnersSection.scss';
import { Button } from 'react-bootstrap';

export const PartnersSection = ({
  link,
  title,
  category,
  text,
  logo,
}) => {
  const { screenSize } = useContext(AppContext);

  const handleClick = () => {
    window.open(link, '_blank')
  }

  return (
    <div className={`partners-section`}>
      <div className='center'>
        <img className='partner-logo'
          alt=""
          src={logo.src}
          width={screenSize == 'mobile' ? logo.widthMobile : logo.widthDesktop}
          height={screenSize == 'mobile' ? logo.heightMobile : logo.heightDesktop}
        />
        {/* <h2 className="sub-title" onClick={handleClick}>
          {title}
          <img src={LinkIcon} alt="" />
        </h2> */}
        <p>{text}</p>
        <div className='bot-ctrls d-flex align-items-center'>
          <Button onClick={handleClick} className='learn-more arrow-right'>{link.replace('https://', '')}</Button>
          <span>{category}</span>
        </div>
      </div>
    </div>
  )
}